import React from "react";

import { FlexDiv } from "../../../components/Atoms";
import SingleComment from "./SingleComment";

import { StyledComments, Name, RecentFilter, RecentFilterText } from "./style";

const Comments = ({ comments, showBanner }) => {
  const CommentHeader = (
    <FlexDiv justifyContent="space-between">
      <Name
        variant="label3"
        fontSize="12px"
        lineHeight="16px"
        fontFamily="var(--man-500)"
      >
        All comments
      </Name>
      <RecentFilter
        icon="icon-recent"
        iconHeight="14px"
        iconWidth="14px"
        iconMargin="2px"
        onClick={showBanner}
      >
        <RecentFilterText
          variant="label3"
          fontSize="12px"
          lineHeight="16px"
          fontFamily="var(--man-600)"
        >
          Most recent
        </RecentFilterText>
      </RecentFilter>
    </FlexDiv>
  );

  return (
    <StyledComments>
      {CommentHeader}
      {comments?.map((comment) => (
        <SingleComment key={comment.id} {...comment} showBanner={showBanner} />
      ))}
    </StyledComments>
  );
};

export default Comments;
